<!--
 * @Author: Gaho
 * @Date: 2023-12-19 09:56:23
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-11 15:10:18
-->
<template>
    <q-table
        hide-pagination
        row-key="name"
        :title="$t('jackpot.LastWinners')"
        :no-data-label="$t('Noinformation')"
        :rows="tableData"
        :columns="columns"
        virtual-scroll
        :pagination="{
            rowsPerPage: 0,
        }"
    >
        <template v-slot:body="props">
            <q-tr :props="props">
                <!-- 时间 -->
                <q-td key="date">
                    <p class="td-date !flex flex-col justify-center w-full">
                        <span>
                            {{ moment(props.row.date).format('YYYY/MM/DD') }}
                        </span>
                        <!-- ↓添加类名，防止 AM 与时间分到2个行上 -->
                        <span class="whitespace-nowrap">
                            {{
                                localeLang === 'cn'
                                ? moment(props.row.date).format('HH:mm:ss')
                                : moment(props.row.date).format('hh:mm:ss A')
                            }}
                        </span>
                    </p>
                </q-td>
                <!-- 玩家 -->
                <q-td key="name" @click.prevent="handleRowClick(props.row)">
                    <p class="td-name">
                        <UserAvatar
                            class="shrink-0"
                            size="22px"
                            :src="props.row?.user?.avatar"
                        />
                        <span class="ml-2 leading-[22px] truncate">
                            {{ props.row?.user?.name }}
                        </span>
                    </p>
                </q-td>
                <!-- 分发 -->
                <q-td key="amountInUsd">
                    <p class="td-amount">
                        <CurrentCoin :name="props.row.currency" />
                        <span> ${{ getFixed(props.row.amount) }} </span>
                        <q-tooltip class="triangle" anchor="top start" self="bottom start">
                            <p class="td-amount">
                                <CurrentCoin :name="currentCurrency" />
                                <span> {{ handleCalculateRate(props.row) }} </span>
                            </p>
                        </q-tooltip>
                    </p>
                </q-td>
            </q-tr>
        </template>
        <template v-slot:no-data="{ message }">
            <p class="no-data-message">
                {{ message }}
            </p>
        </template>
    </q-table>
    <!-- ↓查看获奖人员信息 -->
    <CasinoHistoryModalUserProfile
        v-model="userModal"
        :user-id="currentUserId"
    />
</template>

<script lang="ts">
import { useRatesStore } from '@/stores/cansino/rates';
import useSettingsStore from '@/stores/settings';

import { defineComponent } from 'vue';
import moment from 'moment';
import useTranslation from '~/i18n/useTransLation';
import 'quasar/src/components/table/QTable.sass';

export default defineComponent({
    props: {
        tableData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            columns: [
                {
                    name: useTranslation().Time,
                    label: useTranslation().Time,
                    field: 'date',
                    align: 'left',
                },
                {
                    name: useTranslation().GameDetails.Player,
                    label: useTranslation().GameDetails.Player,
                    field: 'name',
                    align: 'left',
                },
                {
                    name: useTranslation().payout,
                    label: useTranslation().payout,
                    field: 'amountInUsd',
                    align: 'left',
                },
            ],
            userModal: false,
            currentUserId: '',
            rateStore: useRatesStore(),
            moment: moment,
        };
    },
    computed: {
        localeLang(){
            return useI18n().locale.value;
        },
        currentCurrency() {
            return useSettingsStore().pickedCurrency || 'btc';
        },
    },
    methods: {
        /**
         * 查看用户信息
         */
        handleRowClick(row) {
            console.log('event, row, index ↓\n', deepCopy(row));
            this.currentUserId = row.user._id;
            this.userModal = true;
        },
        /**
         * 通过实时汇率计算分发金额
         * @param item 当前用户数据
         */
        handleCalculateRate(item) {
            const { amount, currency } = item;
            // 如果接口返回的当前货币是usdt，则可以根据汇率直接转换为当前所选货币
            if (currency === 'usdt'){
                const currentRate = this.rateStore.comparisonCurrencyList[`${currency}${this.currentCurrency}`];
                return (currentRate * amount).toFixed(2);
            } else { // 如果是其他货币，则需要先转换为usdt，再转换为其他货币
                return handleExchangeRate(amount, currency).toFixed(2);
            }
        },
    },
});
</script>

<style lang="scss" scoped>

.td-amount {
    font-weight: 600;
    letter-spacing: -0.5px;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #fff;

    img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }
}
</style>
